import { createSlice } from '@reduxjs/toolkit';

const skillSlice = createSlice({
  name: 'skill',
  initialState: {
    skills: [],
    languages: [],
    dataValid: false
  },
  reducers: {
    setSkills(state, action) {
        console.count("skillSlice: setSkills");
        if (!action || !action.payload || !action.payload.skills) {
          state.skills = [];    
        } else {
          state.skills = action.payload.skills;
        }      
    },
    setSkill(state, action) {
      if (!action || !action.payload || !!action.payload.skill) return;
      state.skills = state.skills
          .filter((item) => item.id !== action.payload.skill.id)
          .push(action.payload.skill);
    },
    removeSkill(state, action) {
      if (!action || !action.payload || !!action.payload.skill) return;
      state.skills = state.skills.filter((item) => item.id !== action.payload.skill.id);
    },
    setLanguages(state, action) {
      if (!action || !action.payload || !action.payload.languages) {
        state.languages = [];    
      } else {
        state.languages = action.payload.languages;
      }      
    },
    setLanguage(state, action) {
      if (!action || !action.payload || !!action.payload.language) return;
      state.languages = state.languages
          .filter((item) => item.id !== action.payload.languages.id)
          .push(action.payload.languages);
    },
    removeLanguage(state, action) {
      if (!action || !action.payload || !!action.payload.language) return;
      state.languages = state.languages.filter((item) => item.id !== action.payload.language.id);
    },
    invalidateData(state, action) {
        state.dataValid = false;
      },
    },
});

export const skillActions = skillSlice.actions;

export default skillSlice;